/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";

/** @module core/modules/object-utils/prettify */
import { STRINGS } from '../../../constants/strings.js';
/**
 * @description Stringifies and pretty-prints input object. Does not check for circular references.
 * @param {(Object<string,*>|Array<*>)} input - Input object.
 * @returns {string} Prettified object string.
 */

function prettify(input) {
  return _JSON$stringify(input, null, STRINGS.STD_TAB_SPACE);
}

export { prettify };